<template>
<div>      
       <sidebar></sidebar>
    <div class="page">
      <!-- navbar-->
          <headermenu header="Customers"></headermenu>

      <section class="forms">
        <div class="container-fluid">
          <!-- Page Header-->
           <header> 
            <h1 class="h3 display">Customer List</h1>
          </header>

          <div class="row"> 
                
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header">

                <div class="input-group">
                    <input type="text" placeholder="Search Customer" class="form-control" v-model="searchval">
                    <div class="input-group-append">
                      <button type="button" class="btn btn-outline-secondary"><i class="fa fa-search"></i></button>
                    </div>
                </div>

                </div>
               </div>
            </div>
 
               
           <customercard v-for="(customer, index) in customers_temp"
           :name="customer.name" 
           :imageval="customer.image"
           :email="customer.email"
           :phone="customer.phone"
           :key="index"
           > 
           
           </customercard>




          </div>


        </div>
       
      </section>        
   
    </div>  <!--Page end -->

</div>         

</template>

<script>

import headermenu from '@/components/supportcomp/headermenu.vue'      
import sidebar from '@/components/supportcomp/sidebar.vue'
import customercard from '@/components/supportcomp/customer_card.vue'


export default {
  name: 'home',
  data () {
    return {

        searchval : "",

        customers : [

             {
                 name : "TestCustomer1",
                 city : "City1",
                 email : "cus1@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-1.png"

             },
             {
                 name : "TestCustomer6",
                 city : "City6",
                 email : "cus6@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-6.png"

             },
             {
                 name : "TestCustomer2",
                 city : "City2",
                 email : "cus2@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-2.png"

             },
             {
                 name : "TestCustomer3",
                 city : "City3",
                 email : "cus3@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-3.png"

             },
             {
                 name : "TestCustomer4",
                 city : "City4",
                 email : "cus4@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-4.png"

             },
             {
                 name : "TestCustomer5",
                 city : "City5",
                 email : "cus5@abc.com",
                 phone : "44335533",
                 image : "static/images/profiles/profile-5.png"

             }                          

             

        ],
      customers_temp : ""  
    }
  },
  components: {
      headermenu,
      sidebar,
      customercard
   },
methods: {
     
     setSecurity : function (){


          
      
      } //

  },
beforeMount : function() {

     var x = this;
     //setTimeout(function(){ }, 200);
     this.customers_temp = this.customers
    
},
mounted : function () {

},

watch: {
       
    searchval : function(val){

     this.customers_temp = this.customers.filter(function (item) {
	   return item.name.includes(val);
     });

    }
}
                
} //


</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/components/customers.vue